import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { useCallback, useMemo, useRef } from 'react';
import { Helmet } from 'react-helmet';
import { ContactMainView } from '@/components/pages/contact/main/ContactMainView/ContactMainView';
import Layout from '@/container/Layout';
import Breadcrumb from '@/container/Layout/Breadcrumb';
import { useAutoKana } from '@/hooks/form/useAutoKana';
import { useNavigate } from '@/hooks/lib/react-router/useNavigate';
import { PROFFIT_DEFAULT_OGP } from '@/utils/constants/assets/s3';
import { contactCasualConfirmPath, contactPath, contactCasualPath, getAbsolutePath, } from '@/utils/router/links';
const title = 'カジュアル相談会 - 入力｜PROFFIT';
const description = 'コンサル活用を前提とせず、進め方や費用水準、社内承認の進め方などの、不安や疑問におこたえします。';
/**
 * カジュアル相談会ページ
 */
export const ContactCasualPage = (props) => {
    const { changeFormState, formState, types } = props;
    const history = useNavigate();
    const firstNameInputRef = useRef(null);
    const lastNameInputRef = useRef(null);
    const { getFurigana: getFuriganaOfFirstName } = useAutoKana({
        targetRef: firstNameInputRef,
    });
    const { getFurigana: getFuriganaOfLastNameKana } = useAutoKana({
        targetRef: lastNameInputRef,
    });
    const onSubmit = useCallback((values) => {
        changeFormState(Object.assign(Object.assign({}, values), {
            first_name_kana: getFuriganaOfFirstName(),
            last_name_kana: getFuriganaOfLastNameKana(),
        }));
        history.push(contactCasualConfirmPath());
    }, [
        changeFormState,
        getFuriganaOfFirstName,
        getFuriganaOfLastNameKana,
        history,
    ]);
    /** パンくず */
    const breadcrumbs = useMemo(() => [
        { link: contactPath(), text: 'お問い合わせ' },
        { text: 'カジュアル相談' },
    ], []);
    return (_jsxs(Layout, Object.assign({ mainClassName: clsx('l-main') }, { children: [_jsxs(Helmet, { children: [_jsx("title", { children: title }), _jsx("meta", { content: description, name: 'description' }), _jsx("meta", { content: title, property: 'og:title' }), _jsx("meta", { content: description, property: 'og:description' }), _jsx("meta", { content: 'website', property: 'og:type' }), _jsx("meta", { content: 'PROFFIT', property: 'og:site_name' }), _jsx("meta", { content: getAbsolutePath(contactCasualPath()), property: 'og:url' }), _jsx("meta", { content: PROFFIT_DEFAULT_OGP, property: 'og:image' })] }), _jsx(Breadcrumb, { lists: breadcrumbs }), _jsx(ContactMainView, { className: clsx('mb-80'), firstNameInputRef: firstNameInputRef, initialValues: formState, lastNameInputRef: lastNameInputRef, onSubmit: onSubmit, title: 'カジュアル相談', types: types })] })));
};
